import { IconChevronLeft, IconChevronRight } from './icons';
import { LimitDropdown, PageButton } from '../common/PaginationControls';

interface IncidentsPaginationProps {
  page: number;
  limit: number;
  total: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
}

export const IncidentsPagination = ({ page, limit, total, onPageChange, onLimitChange }: IncidentsPaginationProps) => {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  const prevDisabled = page <= 1;
  const nextDisabled = page >= totalPages;

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-4 text-sm text-zinc-500">
        <LimitDropdown value={limit} onChange={onLimitChange} />
        <span className="font-mono tabular-nums">
          {total === 0 ? '0' : `${start}–${end}`} sur {total}
        </span>
      </div>

      <div className="flex items-center gap-1">
        <PageButton onClick={() => onPageChange(page - 1)} disabled={prevDisabled}>
          <IconChevronLeft width={14} height={14} />
          <span>Précédent</span>
        </PageButton>
        <PageButton onClick={() => onPageChange(page + 1)} disabled={nextDisabled}>
          <span>Suivant</span>
          <IconChevronRight width={14} height={14} />
        </PageButton>
      </div>
    </div>
  );
};
